import { render } from "./FilterCard.vue?vue&type=template&id=1a1b2a6e&scoped=true"
import script from "./FilterCard.vue?vue&type=script&lang=js"
export * from "./FilterCard.vue?vue&type=script&lang=js"

import "./FilterCard.vue?vue&type=style&index=0&id=1a1b2a6e&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1b2a6e"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QCard,QCardSection,QExpansionItem,QSpace,QSeparator});
